import { JsonElementType, JsonObject, JsonProperty } from "ta-json";

@JsonObject()
export class UsageRightsProperty {
    @JsonProperty("key")
    key: string;

    @JsonProperty("rights_profile_property")
    rightsProfileLinkProperty: string;

    @JsonProperty("usage_rights_request_property")
    usageRightsRequestProperty: string;
}

@JsonObject()
export class UsageRightsRelation {
    @JsonProperty("key")
    key: string;

    @JsonProperty("rights_profile_link_relation")
    rightsProfileLinkRelation: string;

    @JsonProperty("usage_rights_request_link_relation")
    usageRightsRequestLinkRelation: string;

    @JsonProperty("hierarchy_relation")
    hierarchyRelation: string;

    @JsonProperty("role")
    role: string;
}

enum UsageRightsMatchStrategy {
    All = "All",
    Any = "Any",
    SubjectBased = "SubjectBased",
}

@JsonObject()
export class UsageRightsConfiguration {
    @JsonProperty("relations")
    @JsonElementType(UsageRightsRelation)
    relations: Array<UsageRightsRelation>;

    @JsonProperty("properties")
    @JsonElementType(UsageRightsProperty)
    properties: Array<UsageRightsProperty>;

    @JsonProperty("match_strategy")
    matchStrategy: UsageRightsMatchStrategy = UsageRightsMatchStrategy.Any;

    @JsonProperty("maximum_complexity")
    maximumComplexity?: number;
}
